import { APPOINTMENT_TOUR_TYPE_GUIDED, APPOINTMENT_TOUR_TYPE_SELF_GUIDED } from '../constants/config';

export const getIsGuidedTour = appointment => {
    if (!appointment) return;
    const { tour_type, is_video_tour } = appointment;
    return !is_video_tour && String(tour_type) === String(APPOINTMENT_TOUR_TYPE_GUIDED);
};

export const getIsSelfGuidedTour = appointment => {
    if (!appointment) return;
    return String(appointment.tour_type) === String(APPOINTMENT_TOUR_TYPE_SELF_GUIDED);
};

export const getIsVideoTour = appointment => {
    if (!appointment) return;
    return appointment.is_video_tour;
};
